import React, {useEffect, useRef, useState} from "react";
import DraggableComponent from "../../Components/DraggableComponent";
import {CommonUtil} from "../../utils/CommonUtil";
import {Constants} from "../Languages/Constants";
import $ from "jquery";
import {loadMapApi} from "../../utils/GoogleMapsUtils";
import GenericPopup from "../../Components/GenericPopup";

let gMap: google.maps.Map | null = null;
let markers: (google.maps.Marker | google.maps.Polyline)[] = [];
let selectItem: any = null;
const REPOSITION = "Reposition";

const DashboardPopupModal = ({modalShow,handleClosePopup,markerData,isSearchClicked}: any) => {

    const gMapPopupRef = useRef<HTMLDivElement>(null);

    // Consolidated State Object for form fields to render dynamically
    const [selectedDetails, setSelectedDetails] = useState<any>({});

    useEffect(()=>{
        if (!modalShow) return;
        if (window.google) {
            loadGoogleMap();
        } else {
            const googleMapScript = loadMapApi();
            if (googleMapScript) {
                const onLoad = () => loadGoogleMap();
                googleMapScript.addEventListener('load', onLoad);
                return () => googleMapScript.removeEventListener('load', onLoad);
            }
        }
    },[modalShow])

    const loadGoogleMap = () => {
        if(!markerData || !gMapPopupRef.current) return;
        const lat = Number(markerData.lat);
        const lng = Number(markerData.lng);
        gMap = new google.maps.Map(gMapPopupRef.current, {
            zoom: 15, center: { lat, lng },
            gestureHandling: 'greedy', streetViewControl: true, zoomControl: true, fullscreenControl: true,
            draggableCursor: 'pointer',
            fullscreenControlOptions: {position: google.maps.ControlPosition.TOP_RIGHT},
            mapTypeControlOptions: {position: google.maps.ControlPosition.BOTTOM_RIGHT},
        });

        if (gMap) {
            showMarkers();
        }
    }

    const showMarkers = ()=>{
        if (!gMap || !markerData) return;
        const latlngbounds = new google.maps.LatLngBounds();
        const { lat, lng, arrivalLat, arrivalLng, latlngs } = markerData;
        const startPoint = { lat: Number(lat), lng: Number(lng) };
        const endPoint = { lat: Number(arrivalLat), lng: Number(arrivalLng) };

        let avlQty = "";
        let deptAddr = "";
        let arrivalAddr = "";
        if(latlngs && latlngs.length>0){
            const item = latlngs[0];
            avlQty = item.availCount;
            deptAddr = item.departureAddress;
            arrivalAddr = item.arrivalAddress;

            const strSummary = `Reposition ${item.loadType} ${item.equipmentType} ${item.lengthOfTrailer} from city - ${item.departureCity} to city ${item.arrivalCity} paying ${item.movePrice} and allowing ${item.noOfDaysAllowed} Days. Expected delivery date is ${item.arrivalDate} excessed will incur $${item.dailyRate} per day penalty`;

            setSelectedDetails({
                fromLocation: deptAddr,
                toLocation: arrivalAddr,
                departureDate: item.departureDate,
                arrivalDate: item.arrivalDate,
                equipType: item.equipmentType,
                revenue: item.movePrice,
                revenuePerHour: item.revenuePerHour,
                axles: item.numberOfAxles,
                modalYear: item.year,
                equipLength: item.lengthOfTrailer,
                estDrive: item.totalTravelTime,
                totalDist: item.totalDistanceKM,
                bobtail: item.bobtailToPuDistanceKM,
                hook: item.hookDistanceKM,
                dropToTarget: item.dropToTargetDistanceKM,
                availCount: item.availCount,
                availabilityType: item.availabilityType,
                dailyRate: item.dailyRate,
                weeklyRate: item.weeklyRate,
                monthlyRate: item.monthlyRate,
                distanceRate: item.distanceRate,
                engineRate: item.engineRate,
                engineDailyRate: item.engineDailyRate,
                engineWeeklyRate: item.engineWeeklyRate,
                engineMonthlyRate: item.engineMonthlyRate,
                dailyDistanceRate: item.dailyDistanceRate,
                weeklyDistanceRate: item.weeklyDistanceRate,
                monthlyDistanceRate: item.monthlyDistanceRate,
                allowOffer: item.allowOffer,
                daysAllowed: item.noOfDaysAllowed,
                unitNumber: item.unitNumber,
                vin: item.vin,
                isGeneric: item.isGeneric,
                isMarketPlace: item.isMarketPlace === true || item.isMarketPlace === "true",
                sericeType: item.loadType,
                excessDays: item.dailyRate,
                summary: strSummary,
                currency: item.currency
            });

            selectItem = item;
        }
        const gIcon = CommonUtil.showAvailableCount(Number(avlQty));
        
        const startMarker = new google.maps.Marker({position: startPoint, map: gMap, icon:gIcon, title:`Departure: ${deptAddr}`});
        markers.push(startMarker);
        latlngbounds.extend(startPoint);

        const endMarker = new google.maps.Marker({position: endPoint, map: gMap, title:`Arrival: ${arrivalAddr}`});
        markers.push(endMarker);
        latlngbounds.extend(endPoint);

        const line = new google.maps.Polyline({
            path: [startPoint, endPoint],
            strokeOpacity: 0,
            icons: [{icon: {path: "M 0,-1 0,1", strokeOpacity: 1, scale: 4}, offset: "0", repeat: "20px"}],
            map: gMap,
        });
        markers.push(line);
        gMap.fitBounds(latlngbounds);
    }

    const setPopupCenter = () => {
        const popupTop = Math.max(0, (window.innerHeight - 650) / 2);
        const popupLeft = Math.max(0, (window.innerWidth - 1200) / 2);
        $('#devEstPopup').css({ margin: '0px', top: popupTop, left: popupLeft })
    }

    const onDevAvailShowPopup = () => {
        setTimeout(setPopupCenter, 100);
    }

    const clearMarkers = ()=>{
        markers.forEach(m => m.setMap(null));
        markers = [];
        gMap = null;
    }

    const closePopup = ()=>{
        clearMarkers();
        handleClosePopup();
    }

    const onClickBookItem = ()=>{
        localStorage.setItem("PublicViewTab","true");
        localStorage.setItem("offerPopup","false");
        showAvailDetails();
    }

    const onClickShowAvailability = ()=>{
        localStorage.setItem("PublicViewTab","true");
        localStorage.setItem("offerPopup","true");
        showAvailDetails();
    }

    const showAvailDetails = ()=>{
        if (!selectItem) return;
        localStorage.setItem("startDate",(selectItem.departureDate?CommonUtil.getReservationDateString(selectItem.departureDate):""));
        localStorage.setItem("endDate",(selectItem.arrivalDate?CommonUtil.getReservationDateString(selectItem.arrivalDate):""));
        localStorage.setItem("PublicSearch",CommonUtil.PUBLIC_SEARCH_DB?"true":"false");
        
        const params = new URLSearchParams({
            requestor: "equippublicview",
            equipId: selectItem.equipmentId,
            avaiId: selectItem.availabilityId,
            isGeneric: selectItem.isGenericEquipment,
            equipType: selectItem.equipmentType
        });
        window.open(`${window.location.origin}/?${params.toString()}`, '_blank');
    }

    const tableRows = [
        { label: "Departure", value: selectedDetails?.fromLocation },
        { label: "Arrival", value: selectedDetails?.toLocation },
        { label: "Departure Date", value: selectedDetails?.departureDate },
        { label: "Arrival Date", value: selectedDetails?.arrivalDate },
        { label: "Service Type", value: selectedDetails?.sericeType, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Days Allowed for Reposition", value: selectedDetails?.daysAllowed, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Excess Days Penalty", value: selectedDetails?.excessDays, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Total Distance (KM)", value: selectedDetails?.totalDist, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Revenue", value: selectedDetails?.revenue, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Revenue Per Hour", value: selectedDetails?.revenuePerHour, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Bobtail to PU (KM)", value: selectedDetails?.bobtail, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Hook (KM)", value: selectedDetails?.hook, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Drop to Target", value: selectedDetails?.dropToTarget, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Est. Drive (HRS)", value: selectedDetails?.estDrive, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Equipment Type", value: selectedDetails?.equipType },
        { label: "Equipment Number / Name", value: selectedDetails?.unitNumber },
        { label: "VIN", value: selectedDetails?.vin },
        { label: "Generic/Specific", value: selectedDetails?.isGeneric },
        { label: "Summary", value: selectedDetails?.summary, show: selectedDetails?.availabilityType === REPOSITION },
        { label: "Daily Rate", value: selectedDetails?.dailyRate, show: selectedDetails?.availabilityType !== REPOSITION },
        { label: "Weekly Rate", value: selectedDetails?.weeklyRate, show: selectedDetails?.availabilityType !== REPOSITION },
        { label: "Monthly Rate", value: selectedDetails?.monthlyRate, show: selectedDetails?.availabilityType !== REPOSITION },
        { label: "Distance Rate", value: selectedDetails?.distanceRate, show: selectedDetails?.availabilityType !== REPOSITION && selectedDetails?.isMarketPlace },
        { label: "Engine Rate", value: selectedDetails?.engineRate, show: selectedDetails?.availabilityType !== REPOSITION && selectedDetails?.isMarketPlace },
        { label: "Distance Daily Rate", value: selectedDetails?.dailyDistanceRate ? selectedDetails.currency + " " + selectedDetails?.dailyDistanceRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace },
        { label: "Distance Weekly Rate", value: selectedDetails?.weeklyDistanceRate ? selectedDetails.currency + " " + selectedDetails?.weeklyDistanceRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace },
        { label: "Distance Monthly Rate", value: selectedDetails?.monthlyDistanceRate ? selectedDetails.currency + " " + selectedDetails?.monthlyDistanceRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace },
        { label: "Engine Daily Rate", value: selectedDetails?.engineDailyRate ? selectedDetails.currency + " " + selectedDetails?.engineDailyRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace && selectedDetails?.equipType?.toLowerCase().includes("reefer") },
        { label: "Engine Weekly Rate", value: selectedDetails?.engineWeeklyRate ? selectedDetails.currency + " " + selectedDetails?.engineWeeklyRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace && selectedDetails?.equipType?.toLowerCase().includes("reefer") },
        { label: "Engine Monthly Rate", value: selectedDetails?.engineMonthlyRate ? selectedDetails.currency + " " + selectedDetails?.engineMonthlyRate : null, show: selectedDetails?.availabilityType !== REPOSITION && !selectedDetails?.isMarketPlace && selectedDetails?.equipType?.toLowerCase().includes("reefer") },
    ];

    return (
        <GenericPopup 
            mode={modalShow} 
            header={CommonUtil.getMessageText(Constants.AVL_DETAILS, 'Availability Details')} 
            onClose={closePopup}
            size="xl"
            action={true}
            centeredHeader={true}
        >
            <div className="row">
                <div className="col-xl-8 col-lg-12 col-md-12 m-m-b-15 float-end map-grid" style={{paddingRight:"1px"}}>
                    <div className="w-100 h-100 min-vh-50">
                        <div className="map-container w-100 h-100 pb-3">
                            <div ref={gMapPopupRef} id="mapPopupRef" className="map-container__map" style={{height:"100%", minHeight: "60vh"}}></div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-12 col-md-12 m-m-b-15 float-end map-grid d-flex flex-column" style={{borderLeft:"1px solid #e9e1e1"}}>
                    <div className="flex-grow-1" style={{overflowY:"auto", maxHeight: "60vh", paddingBottom: "1rem"}}>
                        <table className="table table-bordered mb-0">
                            <tbody>
                                {tableRows.map((row, index) => (row.show !== false && row.value !== undefined) && (
                                    <tr key={index}>
                                        <td className="tip-align">{row.label}:</td>
                                        <td className="tip-padding">{(row.value === null || row.value === 0 || row.value === "0") ? "-" : row.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-footer" style={{paddingTop:"10px",textAlign:"center",display:(isSearchClicked?"":"")}}>
                    <button type="button" className="btn btn-success" data-dismiss="modal" onClick={onClickBookItem}>
                        Book Now
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" className="btn btn-success" data-dismiss="modal" style={{display:(selectedDetails?.allowOffer === "Y"?"":"none")}} onClick={onClickShowAvailability}>
                        Create Offer
                    </button>
                </div>
            </div>
        </GenericPopup>
    );
};

export default DashboardPopupModal;
